import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const ResumePasswordButton = ({ clickHandler }) => {
    return (<OptionButton
        isMainAction
        iconClass="fa fa-unlock-alt fa-fw"
        clickHandler={clickHandler}
        title={t('options.resumeSeb')}
    />);
};

ResumePasswordButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
};

export default ResumePasswordButton;
